@if(headerType === 'logged') {
    <app-logged-header [strListBool]=listValue [textHeader]=headerTitle></app-logged-header>
} @else if(headerType === 'unlogged') {
    <app-unlogged-header></app-unlogged-header>
}

<main class="atalaya" [ngClass]="{'no-padding': disablePadding, 'scrollable': isScrollable}">
    <loading-indicator></loading-indicator>
    <router-outlet></router-outlet>
</main>

<app-modal></app-modal>
<app-toast></app-toast>